<template lang="pug">
b-container(fluid class="search__container")
    b-row(align-h="center" class="search__wrapper")
        b-col(md="6")
            b-form-input(class="search__field"
                v-model="proteinSearchValue"
                v-on:keyup.enter="getDbResponse(proteinSearchValue)"
                placeholder="Search with Uniprot accession, protein name, ProteomeXchange ID or PDB id"
                )
            button(class="search__icon" @click="getDbResponse(proteinSearchValue)")
                font-awesome-icon(icon="search")
    p {{ proteinSearchValue }}
</template>

<script>
import axios from 'axios'
import router from '../router'
export default {
    name: 'Search',
    data() {
        return {
            proteinSearchValue: '',
            response: []
        }
    },
    methods: {
        // TODO: move to common utils
        getDbResponse: function(protein) {
            console.log(protein);
            axios
                .get(`/scop3ptm/api/protein`, { params: { protein: protein } })
                .then(response => {
                    // JSON responses are automatically parsed.
                    console.log(response)
                    if (this.response !== null) {
                        console.log('if')
                        this.response = response.data
                        this.$store.commit('setSearchString', protein)
                        router.push({
                            name: 'summary',
                            params: {
                                protein: protein,
                                info: response.data[0]
                            }
                        })
                    }
                })
                .catch(e => console.log(e))
        }
    }
}
</script>

<style lang="scss" scoped>
.search__container {
    margin-top: 20px;
}
.search__wrapper {
    position: relative;
}
.search__field {
    border-bottom-color: #ccc;
    width: 50vw;
    color: #2b2b2b;
    cursor: default;
}
.search__icon {
    position: absolute;
    top: -6px;
    right: 0;
    background-color: #e9f1f4;
    width: 50px;
    height: 50px;
    font-size: 1.35em;
    text-align: center;
    border-color: transparent;
    border-radius: 50%;
    pointer-events: none;
    display: inline-block;
    /* transition: background-color 0.2s ease-in-out; */
    background-color: transparent;
    cursor: pointer;
    pointer-events: auto;
}
</style>
